/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TuitionRateType } from './TuitionRateType';
import {
    TuitionRateTypeFromJSON,
    TuitionRateTypeFromJSONTyped,
    TuitionRateTypeToJSON,
    TuitionRateTypeToJSONTyped,
} from './TuitionRateType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTuitionRatePlanResponse
 */
export interface UpdateTuitionRatePlanResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionRatePlanResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateTuitionRatePlanResponse
     */
    name: string;
    /**
     * 
     * @type {TuitionRateType}
     * @memberof UpdateTuitionRatePlanResponse
     */
    rateType: TuitionRateType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTuitionRatePlanResponse
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the UpdateTuitionRatePlanResponse interface.
 */
export function instanceOfUpdateTuitionRatePlanResponse(value: object): value is UpdateTuitionRatePlanResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpdateTuitionRatePlanResponseFromJSON(json: any): UpdateTuitionRatePlanResponse {
    return UpdateTuitionRatePlanResponseFromJSONTyped(json, false);
}

export function UpdateTuitionRatePlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTuitionRatePlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'rateType': TuitionRateTypeFromJSON(json['rateType']),
        'isActive': json['isActive'],
    };
}

export function UpdateTuitionRatePlanResponseToJSON(json: any): UpdateTuitionRatePlanResponse {
    return UpdateTuitionRatePlanResponseToJSONTyped(json, false);
}

export function UpdateTuitionRatePlanResponseToJSONTyped(value?: UpdateTuitionRatePlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'rateType': TuitionRateTypeToJSON(value['rateType']),
        'isActive': value['isActive'],
    };
}

